// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"7d507f69","952":"3286bc1d"}[chunkId] + ".chunk.js";
};